import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthFrame } from '../../components/AuthFrame';
import { requireSupabase } from '../../lib/supabase';

export function ClaimAccessPage() {
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const claim = async () => {
    setBusy(true); setMessage('');
    const { data, error } = await requireSupabase().rpc('claim_pending_access');
    setBusy(false);
    if (error) setMessage(error.message);
    else setMessage(Number(data) > 0 ? `${data} purchase access claim${Number(data) === 1 ? '' : 's'} applied.` : 'No unclaimed purchases were found for your verified email.');
  };
  return (
    <AuthFrame eyebrow="Purchase access" title="Claim your rebuild" description="Use the same verified email used at checkout.">
      <div className="auth-form">
        {message && <div className="form-message">{message}</div>}
        <button className="button primary full" disabled={busy} onClick={claim}>{busy ? 'Checking…' : 'Check for purchased access'}</button>
        <Link className="button secondary full" to="/hub">Return to the hub</Link>
      </div>
    </AuthFrame>
  );
}
